import { useParams, Navigate } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { IMAGES } from "@/lib/content";

const CONTENT = {
  privacy: {
    title: ["Privacy", "Policy"],
    eyebrow: "Legal",
    body: [
      ["Overview", "Planet Trotter Foundation (\"the Foundation\") respects your privacy. This policy explains how we handle information submitted through our website's enquiry and contact forms."],
      ["Information we collect", "When you submit a partnership enquiry or contact message, we collect the details you provide, such as your name, organisation, email, phone number and message. We do not collect this information for any purpose other than responding to your enquiry."],
      ["How we use information", "Your information is used solely to respond to your enquiry, to explore potential collaboration, and to maintain records of correspondence. We do not sell or rent your personal information to any third party."],
      ["Data storage", "Submissions are stored securely in our systems. Access is limited to authorised personnel of the Foundation."],
      ["Your choices", "You may request that we update or delete the information you have submitted by contacting us using the details on our Contact page."],
      ["Updates", "This policy may be updated as the Foundation's programmes and operations develop. The latest version will always be available on this page."],
    ],
  },
  terms: {
    title: ["Terms", "of Use"],
    eyebrow: "Legal",
    body: [
      ["Acceptance", "By accessing and using this website, you agree to these terms of use. If you do not agree, please do not use the site."],
      ["Purpose of the website", "This website provides information about Planet Trotter Foundation, its vision, its intended areas of work and opportunities for partnership. It is informational in nature."],
      ["No solicitation of donations", "This website does not solicit donations. Any future donation or support functionality will only be introduced once all applicable registrations and compliance requirements are confirmed."],
      ["Intellectual property", "The content, design and materials on this website are the property of Planet Trotter Foundation unless otherwise stated, and may not be reproduced without permission. Imagery may be thematic and illustrative."],
      ["Accuracy", "As a newly established organisation, the Foundation uses forward-looking language to describe its intended work. Information will be updated as programmes develop."],
      ["Contact", "Questions about these terms may be directed to us via the Contact page."],
    ],
  },
  disclaimer: {
    title: ["Disclaimer"],
    eyebrow: "Legal",
    body: [
      ["Newly established organisation", "Planet Trotter Foundation is a newly established Section 8 company. Descriptions of our work use forward-looking language (\"we aim to\", \"we intend to\", \"we are established to\") and represent intended objectives rather than completed activities."],
      ["No claims of past results", "Unless expressly stated and verified, the Foundation does not claim completed projects, beneficiaries, impact statistics, partnerships, awards or registrations. Any impact figures will be published only when verified."],
      ["Imagery", "Photographs used on this website are thematic and editorial. They do not depict specific Planet Trotter Foundation projects unless expressly stated."],
      ["Registrations & exemptions", "The Foundation does not claim any tax exemption or statutory registration (such as 12A, 80G, FCRA or CSR registration) that has not been separately verified and published."],
      ["External links", "The website may reference external organisations or resources. The Foundation is not responsible for the content of external websites."],
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const data = CONTENT[doc];
  if (!data) return <Navigate to="/" replace />;

  return (
    <>
      <Seo title={data.title.join(" ")} path={`/legal/${doc}`} />
      <PageHero eyebrow={data.eyebrow} titleLines={data.title} image={IMAGES.forest} />
      <section className="bg-ptf-bg py-24 md:py-32">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 lg:px-12">
          {data.body.map(([heading, text]) => (
            <div key={heading} className="mb-10">
              <h2 className="font-display uppercase text-2xl tracking-tight text-ptf-primary mb-3">{heading}</h2>
              <p className="text-ptf-text/75 leading-relaxed">{text}</p>
            </div>
          ))}
          <p className="mt-12 text-xs text-ptf-text/45">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}</p>
        </div>
      </section>
    </>
  );
}
